import React from 'react'
import FormControl from '@mui/material/FormControl'
import { TextField, TextFieldProps } from '@mui/material'

type Props = TextFieldProps & {
  errorMessage?: string | null
  label?: string
}

export function TextArea ({ errorMessage = null, label, ...params }: Props) {
  return (
    <FormControl>
      <TextField {...params} multiline helperText={errorMessage} label={label} />
    </FormControl>
  )
}
